export default "__VITE_ASSET__ec318134__"